export default function useSeoSettings(seoSettings: any) {
	if (seoSettings) {
		useHead({
			meta: [
				!seoSettings.indexPage && {name: 'robots', content: 'noindex'},
				seoSettings.description && {name: 'description', content: seoSettings.description},
				seoSettings.description && {name: 'twitter:description', content: seoSettings.description},
				seoSettings.description && {property: 'og:description', content: seoSettings.description},
			].filter(Boolean),
		});
	}
}
